import { render } from "./BookNowComponent.vue?vue&type=template&id=306ca1e5&scoped=true"
import script from "./BookNowComponent.vue?vue&type=script&lang=js"
export * from "./BookNowComponent.vue?vue&type=script&lang=js"

import "./BookNowComponent.vue?vue&type=style&index=0&id=306ca1e5&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306ca1e5"]])

export default __exports__